import { render, staticRenderFns } from "./TheCrossQuoteTable.vue?vue&type=template&id=596cd56c&scoped=true"
import script from "./TheCrossQuoteTable.vue?vue&type=script&lang=js"
export * from "./TheCrossQuoteTable.vue?vue&type=script&lang=js"
import style0 from "./TheCrossQuoteTable.vue?vue&type=style&index=0&id=596cd56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cd56c",
  null
  
)

export default component.exports